import { useTranslation } from 'react-i18next';
import type { Language } from '../i18n';

/** Current UI language, narrowed for the locale-aware formatters. */
export function useLang(): Language {
  const { i18n } = useTranslation();
  const code = (i18n.resolvedLanguage ?? i18n.language ?? 'de').slice(0, 2);
  return code === 'en' ? 'en' : 'de';
}
